<template>
  <div id="groups-sidebar">
      <Button
          @click="visibleRight = true"
          icon="mdi-school"
          label="Groupes"
          class="p-button-rounded btn-purple ml-3"
          id="teach-space-btn"
        />

      <Sidebar :visible.sync="visibleRight" :baseZIndex="1000" position="right" class="p-sidebar-md bg-purple" id="teach-space">
        <div class="flex flex-col justify-between main-col">
          <div>
            <h2>Parcourir les groupes</h2>

            <div class="mt-5" v-if="!isLoaded">
              <skeleton-loader-vue
                type="rect"
                :width="350"
                :height="50"
                animation="wave"
                rounded
                class="my-2"
              />
              <skeleton-loader-vue
                type="rect"
                :width="350"
                :height="50"
                animation="wave"
                rounded
                class="my-2"
              />
              <skeleton-loader-vue
                type="rect"
                :width="350"
                :height="50"
                animation="wave"
                rounded
                class="my-2"
              />
            </div>

            <div class="mt-5" v-else>
              <router-link class="group-link" :to="`/projects/${idProject}/groups/${master_folder.id}`" v-if="master_folder" :is="idGroup == master_folder.id ? 'div' : 'router-link'">
                <div class="group-item my-2 font-bold">
                  <div>
                    <v-mdi name="mdi-school" class="mr-2"></v-mdi>
                    {{ master_folder.title }}
                  </div>
                  <i v-if="idGroup == master_folder.id">Sélectionné</i>
                  <v-mdi name="mdi-chevron-right" class="" v-else></v-mdi>
                </div>
              </router-link>
              <hr class="my-5 mx-10 border-white">

              <router-link class="group-link" :to="`/projects/${idProject}/groups/${group.id}`" v-for="group in groups" :key="group.id" :is="idGroup == group.id ? 'div' : 'router-link'">
                <div class="group-item my-2" >
                  {{ group.title }}
                  <i v-if="idGroup == group.id">Sélectionné</i>
                  <v-mdi name="mdi-chevron-right" class="" v-else></v-mdi>
                </div>
              </router-link>
              <div v-if="!groups.length">
                <p class="text-center italic">Aucun groupe trouvé</p>
              </div>
            </div>
          </div>
          <div>
            <Button
              v-if="isAdminOfProject && group.is_model === 1"
              @click="SendCode"
              icon="mdi-share"
              label="Partager le code aux groupes"
              class="p-button-rounded p-button-outline btn-white ml-3 mb-3"
            />
          <router-link :to="`/projects/${idProject}/groups`" v-if="isAdminOfProject">
            <Button
                @click="visibleRight = true"
                icon="mdi-account-multiple"
                label="Gestion des groupes"
                class="p-button-rounded p-button-outline btn-white ml-3"
              />
          </router-link>
          </div>
        </div>
      </Sidebar>
  </div>
</template>

<script>

import VueSkeletonLoader from 'skeleton-loader-vue';

import axios from 'axios';

export default {
  name: "GroupsSideBar",
  components: { VueSkeletonLoader },
  data: () => ({
      visibleRight: false,
      isLoaded: false,
      groups: []
  }),
  props: {
    group: Object,
    idProject: String | Number,
    idGroup: String | Number,
  },
  mounted: function(){
    // Récupération de la liste des groupes
    axios
    .get(`${axios.defaults.baseURL}projects/${this.idProject}/teach_groups`,
      { 'headers': {Authorization: `Bearer ${this.$store.state.auth.token}`}}
    ).then(response => {
      if(response.data) {
        this.master_folder = response.data.master_folder
        this.groups = response.data.groups
        this.isLoaded = true
      }
    })
    .catch(error => {
      console.log(error)
    })
    this.visibleRight = false
  },
  computed: {
    isAdminOfProject() {
      const currentUser = this.group.project.members.find(element => element.id === this.$store.state.auth.id);
      let is_admin = false;
      if(currentUser.pivot.is_admin || this.group.project.creator_user_id === this.$store.state.auth.id) {
        is_admin = true
      }
      return is_admin;
    },
  },
  methods: {
    SendCode: function(){
      this.$emit('send-code')
      this.visibleRight = false

    }
  },
};
</script>
